import generateSurveyLists from '../SurveyBuilder/helpers/generateSurveyLists/generateSurveyLists';

const questionsMapping = {
  Camera: 'camera',
  Iframe: 'iframe',
  'Multiple Choice Question': 'mc_question',
  Message: 'message',
  'Open Question': 'open_question',
  Slider: 'slider',
  Video: 'video',
  'Camera (Video)': 'video_camera',
  Voice: 'voice',
  Distributor: 'distributor'
};

export default (action, currentSurveyData, surveyId) => {
  const questionsHistoryStepMapping = currentSurveyData.length
    ? { ...currentSurveyData[currentSurveyData.length - 1].questionsMapping }
    : {};

  const questionsWithQuotas =
    Object.values(questionsHistoryStepMapping) &&
    Object.values(questionsHistoryStepMapping).length &&
    Object.values(questionsHistoryStepMapping).filter(q => {
      if (
        q &&
        q.choices &&
        q.choices.length &&
        q.choices.some(c => c.quotaAmount && c.quotaType)
      ) {
        return true;
      }

      if (
        q &&
        q.branches &&
        q.branches.length &&
        q.branches.some(b => b.quotaAmount && b.quotaType)
      ) {
        return true;
      }

      return false;
    });

  const newSurveyData = {
    questionsMapping: questionsHistoryStepMapping,
    content: currentSurveyData.length
      ? { ...currentSurveyData[currentSurveyData.length - 1].content }
      : {},
    surveyProperties: currentSurveyData.length
      ? { ...currentSurveyData[currentSurveyData.length - 1].surveyProperties }
      : {},
    surveyLists: currentSurveyData.length
      ? { ...currentSurveyData[currentSurveyData.length - 1].surveyLists }
      : [],
    questionsWithQuotas
  };
  const actionArguments = JSON.parse(action.arguments);

  if (actionArguments.survey && actionArguments.survey !== surveyId) {
    window.alert(
      'Some history actions are not from this survey, probably history analysis is wrong'
    );
  }

  if (action.mutation === 'addQuestions') {
    actionArguments.attributes.questions.forEach(q => {
      const newQ = {
        ...q,
        type: questionsMapping[q.type]
      };
      newSurveyData.questionsMapping[q.id] = newQ;
    });
    newSurveyData.content =
      actionArguments.attributes.content ||
      actionArguments.attributes.surveyContent;
    newSurveyData.surveyLists = generateSurveyLists(
      newSurveyData.content,
      newSurveyData.questionsMapping
    );
  }
  if (action.mutation === 'updateQuestion') {
    let questionDetails = {};
    if (
      newSurveyData.questionsMapping[actionArguments.attributes.question.id]
    ) {
      questionDetails = {
        ...newSurveyData.questionsMapping[
          actionArguments.attributes.question.id
        ],
        ...actionArguments.attributes.question
      };
    } else {
      questionDetails = actionArguments.attributes.question;
    }

    // TODO: For some reason distributor does not have type in history
    if (
      questionDetails &&
      !questionDetails.type &&
      questionDetails.branches &&
      questionDetails.branches.length
    ) {
      questionDetails.type = 'distributor';
    }

    newSurveyData.questionsMapping[
      actionArguments.attributes.question.id
    ] = questionDetails;

    newSurveyData.surveyLists = generateSurveyLists(
      newSurveyData.content,
      newSurveyData.questionsMapping
    );
  }
  if (action.mutation === 'deleteQuestions') {
    actionArguments.attributes.ids.forEach(id => {
      delete newSurveyData.questionsMapping[id];
    });
    newSurveyData.content = actionArguments.attributes.surveyContent;
    newSurveyData.surveyLists = generateSurveyLists(
      newSurveyData.content,
      newSurveyData.questionsMapping
    );
  }
  if (
    action.mutation === 'updateSurvey' ||
    action.mutation === 'updateTargetAudience'
  ) {
    if (actionArguments && actionArguments.attributes) {
      if (actionArguments.attributes.content) {
        newSurveyData.content = actionArguments.attributes.content;
      }
    }

    newSurveyData.surveyProperties = {
      ...newSurveyData.surveyProperties,
      ...actionArguments.attributes
    };

    if (
      actionArguments &&
      actionArguments.attributes &&
      actionArguments.attributes.userFilter
    ) {
      newSurveyData.surveyProperties.userFilter = JSON.parse(
        actionArguments.attributes.userFilter
      );
    }
  }

  newSurveyData.surveyProperties.content = newSurveyData.content;

  // console.log(currentSurveyData[currentSurveyData.length - 1]);

  return newSurveyData;
};
